const PROGRESS_MIN = 0;
const PROGRESS_MAX = 100;

export const clampProgress = (progress: number): number =>
  Math.min(PROGRESS_MAX, Math.max(PROGRESS_MIN, progress));
